import { SkeletonBox } from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'

const Container = styled(Box)`
  align-items: center;
  display: flex;
  gap: 10px;
`

const LeftSide = styled(Box)`
  display: flex;
  flex-direction: column;
  flex: 0.7;
  gap: 7px;
`

const Title = styled(Typography)`
  color: white;
  font-size: 16px;
  font-weight: 300;
  line-height: 16px;
`

const Description = styled(Box)`
  color: #838383;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  gap: 5px;
  line-height: 16px;
`

const RightSide = styled(SkeletonBox)`
  flex: 0.3;
  min-height: 25px;
  min-width: 125px;
`

const RentalSettingInput: FC<Props> = props => {
  const { description, input, loading, title } = props

  return (
    <Container>
      <LeftSide>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </LeftSide>
      <RightSide loading={loading}>{input}</RightSide>
    </Container>
  )
}

type Props = {
  description: ReactNode
  input: ReactNode
  loading: boolean
  title: string
}

export default RentalSettingInput
